import produce from 'immer';
import { unitsChannelsActions } from './actions';
import { GROUP_DEVICES_ACTIONS } from '../groupDevices/actions';

const initialState = {
  units: [],
  loading: false,
  loaded: false,
  errorMessage: '',
  actionType: '',
  success: false,
  fetchError: false,
  saveSuccess: false,
  saveError: false,
  saveLoading: false,
  addSuccess: false,
  addError: false,
  addLoading: false,
  deleteSuccess: false,
  deleteError: false,
  deleteLoading: false,
  deviceChannels: [],
  isLoadingDeviceChannels: false,
  isDeviceChannelsSuccess: false,
  backgroundDeviceChannels: [],
};

const DataView = (state = initialState, action) => {
  const { type: actionType, payload } = action;
  switch (actionType) {
    case unitsChannelsActions.FETCH_UNITS:
      return produce(state, (draft) => {
        draft.units = [];
        draft.loading = true;
        draft.loaded = false;
        draft.errorMessage = '';
        draft.success = false;
        draft.fetchError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.FETCH_UNITS_SUCCESS:
      return produce(state, (draft) => {
        draft.units = payload;
        draft.loading = false;
        draft.loaded = true;
        draft.success = true;
        draft.fetchError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.FETCH_UNITS_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.loaded = true;
        draft.errorMessage = payload;
        draft.success = false;
        draft.fetchError = true;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.FETCH_UNITS_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.errorMessage = '';
        draft.success = false;
        draft.fetchError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.FETCH_DEVICE_CHANNELS:
      return produce(state, (draft) => {
        draft.deviceChannels = [];
        draft.isLoadingDeviceChannels = true;
        draft.isDeviceChannelsSuccess = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.BACKGROUND_FETCH_DEVICE_CHANNELS:
      return produce(state, (draft) => {
        draft.actionType = actionType;
      });
    case unitsChannelsActions.BACKGROUND_FETCH_DEVICE_CHANNELS_SUCCESS:
      return produce(state, (draft) => {
        draft.backgroundDeviceChannels = payload;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.FETCH_DEVICE_CHANNELS_SUCCESS:
      return produce(state, (draft) => {
        draft.deviceChannels = payload;
        draft.isLoadingDeviceChannels = false;
        draft.isDeviceChannelsSuccess = true;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.FETCH_DEVICE_CHANNELS_ERROR:
      return produce(state, (draft) => {
        draft.isLoadingDeviceChannels = false;
        draft.isDeviceChannelsSuccess = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.FETCH_DEVICE_CHANNELS_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.isDeviceChannelsSuccess = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.SAVE_UNIT_CONFIG:
      return produce(state, (draft) => {
        draft.saveLoading = true;
        draft.loaded = false;
        draft.errorMessage = '';
        draft.saveSuccess = false;
        draft.saveError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.SAVE_UNIT_CONFIG_SUCCESS:
      return produce(state, (draft) => {
        draft.saveLoading = false;
        draft.loaded = true;
        draft.saveSuccess = true;
        draft.saveError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.SAVE_UNIT_CONFIG_ERROR:
      return produce(state, (draft) => {
        draft.saveLoading = false;
        draft.loaded = true;
        draft.errorMessage = payload;
        draft.saveSuccess = false;
        draft.saveError = true;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.SAVE_UNIT_CONFIG_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.saveLoading = false;
        draft.errorMessage = '';
        draft.saveSuccess = false;
        draft.saveError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.ADD_UNIT:
      return produce(state, (draft) => {
        draft.addLoading = true;
        draft.loaded = false;
        draft.errorMessage = '';
        draft.addSuccess = false;
        draft.addError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.ADD_UNIT_SUCCESS:
      return produce(state, (draft) => {
        draft.addLoading = false;
        draft.loaded = true;
        draft.addSuccess = true;
        draft.addError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.ADD_UNIT_ERROR:
      return produce(state, (draft) => {
        draft.addLoading = false;
        draft.loaded = true;
        draft.errorMessage = payload;
        draft.addSuccess = false;
        draft.addError = true;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.ADD_UNIT_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.addLoading = false;
        draft.errorMessage = '';
        draft.deleteSuccess = false;
        draft.deleteError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.DELETE_UNIT:
      return produce(state, (draft) => {
        draft.deleteLoading = true;
        draft.loaded = false;
        draft.errorMessage = '';
        draft.deleteSuccess = false;
        draft.deleteError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.DELETE_UNIT_SUCCESS:
      return produce(state, (draft) => {
        draft.deleteLoading = false;
        draft.loaded = true;
        draft.deleteSuccess = true;
        draft.deleteError = false;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.DELETE_UNIT_ERROR:
      return produce(state, (draft) => {
        draft.deleteLoading = false;
        draft.loaded = true;
        draft.errorMessage = payload;
        draft.deleteSuccess = false;
        draft.deleteError = true;
        draft.actionType = actionType;
      });
    case unitsChannelsActions.DELETE_UNIT_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.deleteLoading = false;
        draft.errorMessage = '';
        draft.deleteError = false;
        draft.deleteError = false;
        draft.actionType = actionType;
      });

    case GROUP_DEVICES_ACTIONS.UNLINK_GROUP_DEVICE_SUCCESS:
    case GROUP_DEVICES_ACTIONS.ADD_GROUP_DEVICES_SUCCESS:
      return produce(state, (draft) => {
        draft.units = payload.units || state.units || [];
      });
    default:
      return state;
  }
};

export default DataView;
